// Tap-friendly options for the colour / condition / brand declaration fields.
export const COLORS = [
  { key: "black", hex: "#111827" }, { key: "white", hex: "#FFFFFF" }, { key: "grey", hex: "#9CA3AF" },
  { key: "silver", hex: "linear-gradient(135deg,#E5E7EB,#9CA3AF)" }, { key: "gold", hex: "linear-gradient(135deg,#FDE68A,#D4A017)" },
  { key: "brown", hex: "#7C4A21" }, { key: "beige", hex: "#E8D9B5" }, { key: "red", hex: "#DC2626" },
  { key: "pink", hex: "#F472B6" }, { key: "orange", hex: "#F97316" }, { key: "yellow", hex: "#FACC15" },
  { key: "green", hex: "#16A34A" }, { key: "blue", hex: "#2563EB" }, { key: "purple", hex: "#7C3AED" },
  { key: "multi", hex: "conic-gradient(#DC2626,#FACC15,#16A34A,#2563EB,#7C3AED,#DC2626)" },
];
export const MAX_COLORS = 3;

export const CONDITIONS = ["new", "veryGood", "good", "worn", "damaged"];

const TECH = ["Apple", "Samsung", "Anker", "Logitech", "Xiaomi", "SanDisk", "Sony"];
const FASHION = ["Zara", "H&M", "Nike", "Adidas", "Uniqlo", "The North Face", "Levi's", "Lacoste", "Ralph Lauren"];
const BAGS = ["Louis Vuitton", "Longchamp", "Michael Kors", "Eastpak", "Samsonite", "The North Face", "Herschel", "Gucci", "Coach"];
const BIKES = ["Decathlon", "Xiaomi", "Ninebot", "Trek", "Specialized", "Giant", "Brompton"];

export const BRANDS = {
  Telephone: ["Apple", "Samsung", "Xiaomi", "Google", "Huawei", "Oppo", "OnePlus", "Motorola", "Nokia"],
  Ordinateur: ["Apple", "Dell", "HP", "Lenovo", "Asus", "Acer", "Microsoft", "MSI"],
  Tablette: ["Apple", "Samsung", "Lenovo", "Huawei", "Amazon", "Microsoft"],
  Ecouteurs: ["Apple", "Samsung", "Sony", "Bose", "JBL", "Beats", "Sennheiser", "Xiaomi"],
  Montre: ["Apple", "Samsung", "Garmin", "Casio", "Swatch", "Fossil", "Tissot", "Seiko", "Rolex"],
  Lunettes: ["Ray-Ban", "Oakley", "Persol", "Prada", "Gucci", "Dior", "Chanel"],
  Sac: BAGS, SacADos: BAGS, Valise: BAGS, Portefeuille: BAGS, Trousse: BAGS,
  Vetements: FASHION, Manteau: FASHION, Echarpe: FASHION, Gants: FASHION, Casquette: FASHION, Ceinture: FASHION,
  Chaussures: ["Nike", "Adidas", "New Balance", "Puma", "Converse", "Vans", "Asics"],
  Console: ["Nintendo", "PlayStation", "Xbox", "Steam Deck"],
  AppareilPhoto: ["Canon", "Nikon", "Sony", "Fujifilm", "Panasonic", "GoPro", "Leica"],
  Enceinte: ["JBL", "Bose", "Sony", "Marshall", "Ultimate Ears", "Bang & Olufsen"],
  Chargeur: TECH, USB: TECH, Souris: TECH, Electronique: TECH,
  Liseuse: ["Kindle", "Kobo", "PocketBook"],
  Velo: BIKES, Trottinette: BIKES,
  Poussette: ["Bugaboo", "Babyzen YOYO", "Cybex", "Chicco", "Maxi-Cosi"],
  Bijoux: ["Pandora", "Cartier", "Swarovski", "Tiffany & Co."],
  CleVoiture: ["Renault", "Peugeot", "Citroën", "Volkswagen", "Toyota", "BMW", "Mercedes-Benz", "Tesla"],
  Gourde: ["Chilly's", "Qwetch", "CamelBak", "Hydro Flask", "Stanley"],
  Sport: ["Decathlon", "Nike", "Adidas", "Wilson", "Head"],
  Parapluie: ["Totes", "Isotoner", "Knirps"],
};
